import { createRouter, createWebHashHistory, createWebHistory } from "vue-router";
import MainMenu from "../components/MainMenu.vue";
import Index from "../components/Index.vue";
import SpeedRunning from "../components/Gaming/SpeedRunning.vue";
import ControllerModding from "../components/Gaming/ControllerModding.vue";
import MarbleBlastUltra from "../components/Gaming/MarbleBlastUltra.vue";
import OtherGames from "../components/Gaming/OtherGames.vue";
import HobohatGames from "../components/GameDev/HobohatGames.vue";
import Iclone from "../components/GameDev/Iclone.vue";
import LetsBeFriends from "../components/GameDev/LetsBeFriends.vue";
import PhaseShift from "../components/GameDev/PhaseShift.vue";
import NinjaLegend from "../components/GameDev/NinjaLegend.vue";
import GettingIntoProgramming from "../components/Programming/GettingIntoProgramming.vue";
import PersonalProjects from "../components/Programming/PersonalProjects.vue";
import Cloudflare from "../components/Programming/Cloudflare.vue";
import VisualStudioBeginnerTricks from "../components/Programming/VisualStudioBeginnerTricks.vue";
import PcBuild from "../components/HardwareSoftware/PcBuild.vue";
import AutomaticPlexTorrenting from "../components/HardwareSoftware/AutomaticPlexTorrenting.vue";
import AutoUpdateCloudflareDNS from "../components/HardwareSoftware/AutoUpdateCloudflareDNS.vue";
import AboutMe from "../components/AboutMe.vue";
import PersonalProjectsSecure from "../components/Tools/PersonalProjectsSecure.vue";

const routes = [
  {
    path: "/",
    component: Index,
    name: "Home",
    meta: {
      title: "Home - Skillvolution",
      description: "Skillvolution, from speedrunning world records to game development and tech builds, explore insights on gaming strategies, programming, and high-performance hardware."
    }
  },
  {
    path: "/pc-build",
    component: PcBuild,
    name: "PC Build",
    meta: {
      title: "PC Build - Skillvolution",
      description: "Explore my custom-built high-performance PC, optimized for gaming, development, and virtualization. Full specs and setup details."
    }
  },
  {
    path: "/speed-running",
    component: SpeedRunning,
    name: "Speed Running",
    meta: {
      title: "Speed Running - Skillvolution",
      description: "My journey through speedrunning, world records, strategies, and insights into the games I mastered."
    }
  },
  {
    path: "/marble-blast-ultra",
    component: MarbleBlastUltra,
    name: "Marble Blast Ultra",
    meta: {
      title: "Marble Blast Ultra Speedrunning - Skillvolution",
      description: "My experiences speedrunning Marble Blast Ultra, including leaderboard placements, glitches, and controller modifications."
    }
  },
  {
    path: "/other-games",
    component: OtherGames,
    name: "Other Games",
    meta: {
      title: "Other Games - Skillvolution",
      description: "Speedrunning and competitive gaming across multiple titles. Insights into strategy, leaderboards, and high-level gameplay."
    }
  },
  {
    path: "/hobohat-games",
    component: HobohatGames,
    name: "HoboHat Games",
    meta: {
      title: "HoboHat Games - Skillvolution",
      description: "Indie game development with HoboHat Games. A look into the games we built and the experiences from our journey."
    }
  },
  {
    path: "/iclone",
    component: Iclone,
    name: "Iclone",
    meta: {
      title: "Iclone Game Development - Skillvolution",
      description: "Game development insights using Iclone. From concept to execution, explore tools and techniques used in our projects."
    }
  },
  {
    path: "/ninja-legend",
    component: NinjaLegend,
    name: "Ninja Legend",
    meta: {
      title: "Ninja Legend - Skillvolution",
      description: "The development story behind Ninja Legend, an RPG built in Roblox, inspired by classic role-playing mechanics."
    }
  },
  {
    path: "/phase-shift",
    component: PhaseShift,
    name: "Phase Shift",
    meta: {
      title: "Phase Shift - Skillvolution",
      description: "A deep dive into the mechanics, design, and development process behind the game Phase Shift."
    }
  },
  {
    path: "/lets-be-friends",
    component: LetsBeFriends,
    name: "Let's Be Friends",
    meta: {
      title: "Let's Be Friends - Skillvolution",
      description: "Exploring the development and impact of 'Let's Be Friends' and how it became one of our most played games."
    }
  },
  {
    path: "/getting-into-programming",
    component: GettingIntoProgramming,
    name: "Getting Into Programming",
    meta: {
      title: "Getting Into Programming - Skillvolution",
      description: "How I started programming, from early modding to building full-fledged applications and games."
    }
  },
  {
    path: "/personal-projects",
    component: PersonalProjects,
    name: "Personal Projects",
    meta: {
      title: "Personal Projects - Skillvolution",
      description: "A collection of my personal software and game development projects, including automation scripts and custom-built tools."
    }
  },
  {
    path: "/automatic-plex-torrenting",
    component: AutomaticPlexTorrenting,
    name: "Automatic Plex Torrenting",
    meta: {
      title: "Automatic Plex Torrenting - Skillvolution",
      description: "Setting up an automated Plex media server with torrenting, Jackett, Radarr, Sonarr, and a secure VM setup."
    }
  },
  {
    path: "/about-me",
    component: AboutMe,
    name: "About Me",
    meta: {
      title: "About Me - Skillvolution",
      description: "A deep dive into my background, interests, and journey in gaming, programming, and tech."
    }
  },
  {
    path: "/personal-projects-secure",
    component: PersonalProjectsSecure,
    name: "Secure Projects",
    meta: {
      title: "Secure Personal Projects - Skillvolution",
      description: "A deeper look into some of my private projects related to cybersecurity, automation, and personal tools."
    }
  },
  {
    path: "/cloudflare",
    component: Cloudflare,
    name: "Cloudflare",
    meta: {
      title: "Cloudflare Optimization - Skillvolution",
      description: "How I optimized my websites with Cloudflare, including speed improvements, caching, and free SSL."
    }
  },
  {
    path: "/controller-modding",
    component: ControllerModding,
    name: "Controller Modding",
    meta: {
      title: "Controller Modding - Skillvolution",
      description: "Modding controllers for gaming performance, including Xbox 360 modifications for speedrunning advantages."
    }
  },
  {
    path: "/visual-studio-beginner-tricks",
    component: VisualStudioBeginnerTricks,
    name: "Visual Studio Beginner Tricks",
    meta: {
      title: "Visual Studio Beginner Tricks - Skillvolution",
      description: ""
    }
  },
  {
    path: "/auto-update-cloudflare-dns",
    component: AutoUpdateCloudflareDNS,
    name: "Auto Update Cloudflare DNS",
    meta: {
      title: "Auto Update Cloudflare DNS - Skillvolution",
      description: ""
    }
  }

];

const isCapacitor = !!window.Capacitor;


const router = createRouter({
  history: isCapacitor ? createWebHashHistory() :createWebHistory(),
  routes,
});

export default router;
